import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getCarouselSliceContent = createAsyncThunk('/carousels/content', async () => {
	const response = await axios.post(`${API_URL}/getCarousel`);
    console.log(response.data);
	return response;
})

export const carouselSlice = createSlice({
    name: 'carousels',
    initialState: {
        isLoading: false,
        carousels : []
    },
    reducers: {
    },
    extraReducers: {
		[getCarouselSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getCarouselSliceContent.fulfilled]: (state, action) => {
			state.carousels = action.payload.data
			state.isLoading = false
		},
		[getCarouselSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default carouselSlice.reducer